export default {
  OFFLINE_REQUEST: 'OFFLINE_REQUEST',
  SET_OFFLINE_REQUEST: 'SET_OFFLINE_REQUEST',
  RESEND_OFFLINE_REQUESTS: 'RESEND_OFFLINE_REQUESTS',
  RESET_OFFLINE_REQUESTS: 'RESET_OFFLINE_REQUESTS',
  RESET_OFFLINE_ACTION: 'RESET_OFFLINE_ACTION',
  SET_OFFLINE_REQUESTS_STATUS: 'SET_OFFLINE_REQUESTS_STATUS',
};
